import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { ProfileInfo } from '../../profile/models';
import { DashboardExchangeRateList, DashboardRequestActive, VerificationDetail } from '../models';
import { DashboardView } from '../models/dashboard-view';
import { IDashboradNewWalletsModel } from '../models/dashboard-new-wallets.model';


@Injectable({
	providedIn: 'root'
})
export class DashboardService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) { }

	getInfo(): Observable<DashboardView> {
		const url = `${this.appConfig.apiEndpoint}/v2/dashboard/report`;
		return this.http.get<DashboardView>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getExchangeRates(): Observable<DashboardExchangeRateList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/currencies/exchange-rates`;
		return this.http.get<DashboardView>(url)
			.pipe(map(this.utilsService.handleResponse));
	}


	getReqActive(): Observable<DashboardRequestActive[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/requests/active`;
		return this.http.get<DashboardRequestActive[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getSettings(): string {
		let randomNumber = new Date().getTime();
		const url = `https://tc-static-public.topchnge.net/download/app/my.json?v=${randomNumber}`;
		var xmlHttp = new XMLHttpRequest();
		xmlHttp.open("GET", url, false);
		xmlHttp.send(null);
		return xmlHttp.responseText;
	}
}
